// @ts-nocheck

import {
  useMutationEngine,
  useNewQueryEngine,
} from '../../../../queries/useDataEngine';
import { EMPTY_OBJECT } from '../../../../const/CommonConst';
import { LandscapeService } from './landscapeService';

const LANDSCAPE = 'landscape';

export const LANDSCAPE_QUERY_KEYS = {
  ALL: [LANDSCAPE],

  landscapeData: {
    ROOT: [LANDSCAPE, 'landscapeData'],
    key: (params = {}) => [LANDSCAPE, 'landscapeData', params],
  },

  landscapeViewEntities: {
    ROOT: [LANDSCAPE, 'landscapeViewEntities'],
    key: (params = {}) => [LANDSCAPE, 'landscapeViewEntities', params],
  },

  landscapeSingleEntity: {
    ROOT: [LANDSCAPE, 'landscapeSingleEntity'],
    key: (params = {}) => [LANDSCAPE, 'landscapeSingleEntity', params],
  },

  landscapeSavedViews: {
    ROOT: [LANDSCAPE, 'landscapeSavedViews'],
    key: () => [LANDSCAPE, 'landscapeSavedViews'],
  },
};

export const useLandscapeDataQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    LANDSCAPE_QUERY_KEYS.landscapeData.key,
    LandscapeService.getLandScapeData,
    params,
    { ...options, staleTime: 0 }
  );

export const useLandscapeViewEntitiesQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    LANDSCAPE_QUERY_KEYS.landscapeViewEntities.key,
    LandscapeService.getLandScapeViewEntities,
    params,
    { ...options, staleTime: 0 }
  );

export const useLandscapeSingleEntityQuery = ({
  params = EMPTY_OBJECT,
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    LANDSCAPE_QUERY_KEYS.landscapeSingleEntity.key,
    LandscapeService.getLandScapeSingleEntity,
    params,
    { ...options, staleTime: 0 }
  );

export const useLandscapeSavedViewsQuery = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) =>
  useNewQueryEngine(
    LANDSCAPE_QUERY_KEYS.landscapeSavedViews.key,
    LandscapeService.getLandscapeSavedViews,
    EMPTY_OBJECT,
    options
  );

export const useSaveLandscapeViewEntitiesMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(LandscapeService.saveLandscapeViewEntities, {
    ...options,
    invalidateQueries: [LANDSCAPE_QUERY_KEYS.landscapeViewEntities.ROOT],
  });
};

export const useCreateLandscapeViewMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(LandscapeService.createLandscapeView, {
    ...options,
    invalidateQueries: [
      LANDSCAPE_QUERY_KEYS.landscapeSavedViews.ROOT,
      LANDSCAPE_QUERY_KEYS.landscapeViewEntities.ROOT,
    ],
  });
};

export const useDeleteLandscapeSavedViewsMutation = ({
  options = EMPTY_OBJECT,
} = EMPTY_OBJECT) => {
  return useMutationEngine(LandscapeService.deleteLandscapeSavedViews, {
    ...options,
    invalidateQueries: [LANDSCAPE_QUERY_KEYS.landscapeSavedViews.ROOT],
  });
};
